import { render, staticRenderFns } from "./StatisticsSidebar.vue?vue&type=template&id=6dd3a4b5"
import script from "./StatisticsSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatisticsSidebar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StatisticsSidebar.vue?vue&type=style&index=0&id=6dd3a4b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports